import { Component, inject, Input, OnDestroy, OnInit, signal } from "@angular/core";
import { MarketCountdownComponent } from "../../components/market-countdown/market-countdown.component";
import { TranslateModule } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { map, takeUntil } from "rxjs/operators";
import { LiveUpdateService } from "../../../../../../../shared/src/lib/services/live-update.service";
import { layLessSports, timelessSports } from "../../../../../assets/constants/market";
import { combineLatest, Subject } from "rxjs";
import { MarketOpsService } from "../market/market-ops.service";
import { WhiteLabelConfigService } from "../../../../../../../shared/src/lib/services/white-label-config.service";

@Component({
  selector: "app-event-header",
  imports: [MarketCountdownComponent, TranslateModule, RouterLink],
  templateUrl: "./event-header.component.html",
  styleUrl: "./event-header.component.scss",
})
export class EventHeaderComponent implements OnInit, OnDestroy {
  @Input() eventItem: any;
  readonly destroy$ = new Subject<void>();
  liveUpdateService = inject(LiveUpdateService);
  marketOps = inject(MarketOpsService);
  wlConfigService = inject(WhiteLabelConfigService);
  isInPlay = signal<boolean>(false);

  get isRacing() {
    return layLessSports.includes(this.eventItem?.eventType?.id);
  }

  get showStartTime() {
    return !timelessSports.includes(this.eventItem?.eventType?.id);
  }

  ngOnInit() {
    this.getMarketUpdate();
  }

  getMarketUpdate() {
    combineLatest([this.liveUpdateService.getData(), this.marketOps.allMarkets$])
      .pipe(
        map(([update, allMarkets]) => {
          if (allMarkets.length > 0 && update) {
            const matchingUpdate = allMarkets.some((market: any) => market?.marketId === update?.id && update?.ipl);
            if (matchingUpdate) this.isInPlay.set(update?.ipl);
          }
        }),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
